/* UPP redesign header: desktop mega menu (hover with delay, keyboard, touch) and the phone menu dialog.
   Cart drawer, cart count and predictive search stay with theme.js (HeaderSection). */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1200px)';

  function loadImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) {
        img.setAttribute('srcset', img.dataset.srcset);
        img.removeAttribute('data-srcset');
      }
      img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-src');
    });
  }

  function initMega(root) {
    var backdrop = root.querySelector('[data-upp-mega-backdrop]');
    var rooms = Array.prototype.slice.call(root.querySelectorAll('[data-upp-room]'));
    var desktop = window.matchMedia(DESKTOP);
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var current = null;
    var openTimer = null;
    var closeTimer = null;

    function panelOf(li) { return li.querySelector('[data-upp-mega]'); }

    function open(li) {
      clearTimeout(closeTimer);
      if (current === li) return;
      if (current) close(current);
      var panel = panelOf(li);
      if (!panel) return;
      loadImages(panel);
      panel.hidden = false;
      li.classList.add('is-open');
      var toggle = li.querySelector('.upp-hdr__room-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (backdrop) backdrop.hidden = false;
      current = li;
    }

    function close(li, focusEl) {
      var panel = panelOf(li);
      if (panel) panel.hidden = true;
      li.classList.remove('is-open');
      var toggle = li.querySelector('.upp-hdr__room-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (current === li) current = null;
      if (!current && backdrop) backdrop.hidden = true;
      if (focusEl) focusEl.focus();
    }

    rooms.forEach(function (li) {
      var panel = panelOf(li);
      if (!panel) return;
      var link = li.querySelector('.upp-hdr__room-link');
      var toggle = li.querySelector('.upp-hdr__room-toggle');

      li.addEventListener('mouseenter', function () {
        if (!desktop.matches || !hover.matches) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(li); }, current ? 0 : 150);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        if (current !== li) return;
        closeTimer = setTimeout(function () { if (current === li) close(li); }, 250);
      });

      // Touch screens wide enough for the desktop header: first tap opens, second tap follows the link.
      link.addEventListener('click', function (evt) {
        if (hover.matches || current === li) return;
        evt.preventDefault();
        open(li);
      });

      link.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowDown') {
          evt.preventDefault();
          open(li);
          var first = panel.querySelector('a, button');
          if (first) first.focus();
        }
      });

      if (toggle) {
        toggle.addEventListener('click', function (evt) {
          evt.preventDefault();
          if (current === li) close(li); else open(li);
        });
      }

      li.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && current === li) {
          evt.stopPropagation();
          close(li, panel.contains(document.activeElement) && toggle ? toggle : link);
        }
      });

      li.addEventListener('focusout', function (evt) {
        if (current === li && evt.relatedTarget && !li.contains(evt.relatedTarget)) close(li);
      });
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () { if (current) close(current); });
    }
    document.addEventListener('click', function (evt) {
      if (current && !current.contains(evt.target)) close(current);
    });
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && current) close(current);
    });
    var onChange = function () { if (!desktop.matches && current) close(current); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange); else desktop.addListener(onChange);

    return { open: open, close: function () { if (current) close(current); } };
  }

  function initNav(root) {
    var dlg = root.querySelector('[data-upp-nav]');
    var openBtn = root.querySelector('[data-upp-nav-open]');
    if (!dlg || !openBtn) return null;
    var main = dlg.querySelector('[data-upp-nav-main]');
    var lastRoomBtn = null;
    var desktop = window.matchMedia(DESKTOP);

    function showMain(focusEl) {
      dlg.querySelectorAll('[data-upp-nav-panel]').forEach(function (p) { p.hidden = true; });
      dlg.querySelectorAll('[data-upp-nav-sub]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      main.hidden = false;
      if (focusEl) focusEl.focus();
    }

    function showSub(btn) {
      var sub = document.getElementById(btn.getAttribute('data-upp-nav-sub'));
      if (!sub) return;
      lastRoomBtn = btn;
      loadImages(sub);
      main.hidden = true;
      sub.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var scroll = sub.querySelector('.upp-nav__scroll');
      if (scroll) scroll.scrollTop = 0;
      var back = sub.querySelector('[data-upp-nav-back]');
      if (back) back.focus();
    }

    function openNav() {
      if (dlg.open) return;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('upp-nav-open');
      openBtn.setAttribute('aria-expanded', 'true');
    }

    function closeNav() {
      if (!dlg.open) return;
      if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); onClosed(); }
    }

    function onClosed() {
      document.documentElement.classList.remove('upp-nav-open');
      openBtn.setAttribute('aria-expanded', 'false');
      showMain();
      openBtn.focus();
    }

    openBtn.addEventListener('click', openNav);
    dlg.addEventListener('close', onClosed);
    dlg.addEventListener('click', function (evt) {
      if (evt.target === dlg) { closeNav(); return; }
      var t = evt.target.closest('[data-upp-nav-close], [data-upp-nav-back], [data-upp-nav-sub]');
      if (!t) return;
      if (t.hasAttribute('data-upp-nav-close')) closeNav();
      else if (t.hasAttribute('data-upp-nav-back')) showMain(lastRoomBtn);
      else showSub(t);
    });
    var onChange = function () { if (desktop.matches) closeNav(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onChange); else desktop.addListener(onChange);

    return { open: openNav, close: closeNav };
  }

  function init(root) {
    if (!root || root.hasAttribute('data-upp-ready')) return;
    root.setAttribute('data-upp-ready', '');
    var mega = initMega(root);
    initNav(root);

    // Theme editor: open the room's mega menu when one of its blocks is selected.
    document.addEventListener('shopify:block:select', function (evt) {
      if (!root.contains(evt.target)) return;
      var li = evt.target.closest('[data-upp-room]');
      if (li) mega.open(li);
    });
    document.addEventListener('shopify:block:deselect', function (evt) {
      if (root.contains(evt.target)) mega.close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-upp-header]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
